/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalReauthCaseManager
 */
export interface PalReauthCaseManager {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name?: string | null;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    fax?: string | null;
    /**
     * 
     */
    email?: string | null;
}

/**
 * Check if a given object implements the PalReauthCaseManager interface.
 */
export function instanceOfPalReauthCaseManager(value: object): value is PalReauthCaseManager {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PalReauthCaseManagerFromJSON(json: any): PalReauthCaseManager {
    return PalReauthCaseManagerFromJSONTyped(json, false);
}

export function PalReauthCaseManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthCaseManager {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'fax': json['fax'] === undefined ? undefined : json['fax'] === null ? null : json['fax'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
    };
}

export function PalReauthCaseManagerToJSON(json: any): PalReauthCaseManager {
    return PalReauthCaseManagerToJSONTyped(json, false);
}

export function PalReauthCaseManagerToJSONTyped(value?: PalReauthCaseManager | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'phone': value['phone'],
        'fax': value['fax'],
        'email': value['email'],
    };
}

